import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaxIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 13.25V5.5M8 5.5L5.5 8M8 5.5L10.5 8M2 2.75H14" })
});
export default SvgMaxIcon;
